import { useMutation, useQuery } from '@tanstack/react-query';
import { CaseAppealModel } from 'app/edozvola/cases/cases.model';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { ERRORS, messages } from 'app/config/constants';
import { queryClient } from 'app/app';
import { fetchCaseAppeal, saveCaseAppeal } from 'app/edozvola/cases/service/cases.service';
import success = toast.success;

export const saveCaseAppealQuery = (idCase: string) => {
  return useMutation({
    mutationFn: (values: CaseAppealModel) => {
      return saveCaseAppeal(idCase, values);
    },
    onSuccess: () => {
      showToast(success, messages.DATA_SAVED);
      queryClient.invalidateQueries({ queryKey: ['case-appeal'] });
    },
    onError: (err: any) => {
      if (Object.values(ERRORS).includes(err.response?.data?.detail)) {
        showToast(toast.error, err.response?.data?.detail);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    },
  });
};

export const fetchCaseAppealQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-appeal'],
    queryFn: () => fetchCaseAppeal(idCase),
  });
};
